import { Provider } from "@redotech/redo-model/order";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getTeamPrimaryProvider = {
  name: "getTeamPrimaryProvider" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    primaryProvider: createEnum(Provider).nullable(),
    hasShopifyIntegration: z.boolean(),
    hasBigcommerceIntegration: z.boolean(),
    hasCommentSoldIntegration: z.boolean(),
    hasCommerceCloudIntegration: z.boolean(),
  }),
};
